<template>
  <div class="text-container">
    <Heading level="2" align="center">
      {{
        $t(
          'exchange.account.deposits-and-withdrawals-terms-and-conditions.title'
        )
      }}
    </Heading>

    <p>
      {{
        $t(
          'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-a'
        )
      }}
    </p>
    <p>
      {{
        $t(
          'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-b'
        )
      }}
    </p>
    <p>
      {{
        $t(
          'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-c'
        )
      }}
    </p>
    <p>
      {{
        $t(
          'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-d'
        )
      }}
    </p>
    <p>
      {{
        $t(
          'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-e'
        )
      }}
    </p>
    <p>
      {{
        $t(
          'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-f'
        )
      }}
    </p>
    <p>
      {{
        $t(
          'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-g'
        )
      }}
    </p>
    <p>
      {{
        $t(
          'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-h'
        )
      }}
    </p>
    <p>
      {{
        $t(
          'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-i'
        )
      }}
    </p>
    <p>
      {{
        $t(
          'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-j'
        )
      }}
    </p>
    <p>
      {{
        $t(
          'exchange.account.deposits-and-withdrawals-terms-and-conditions.condition-k'
        )
      }}
    </p>

    <ButtonBase variant="primary" block rounded @click="goToNext">
      {{
        $t(
          'exchange.account.deposits-and-withdrawals-terms-and-conditions.accept'
        )
      }}
    </ButtonBase>
  </div>
</template>

<script>
import { ButtonBase, Heading } from '@nauticus-blockchain/nauticus-ui'

export default {
  name: 'TheTermsAndConditions',
  components: {
    ButtonBase,
    Heading,
  },
  props: {
    to: {
      type: [String, Object],
      required: true,
    },
  },
  methods: {
    goToNext() {
      this.$router.push(this.to)
    },
  },
}
</script>

<style lang="scss" scoped>
.text-container {
  p {
    font-size: 1.4rem;
  }
}
</style>
